// extracted by mini-css-extract-plugin
module.exports = {"HeroSimpleImage":"styles_HeroSimpleImage__yM_Ou"};